import { render, staticRenderFns } from "./10.vue?vue&type=template&id=6d29a8d5&scoped=true&"
var script = {}
import style0 from "./10.vue?vue&type=style&index=0&id=6d29a8d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d29a8d5",
  null
  
)

export default component.exports